module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro--chf-b57769a5e40b6a13bd44133dafa4c472.webp";